import { PropsWithChildren } from 'react'

import { Text } from '@revolut-internal/ui-kit'
import { PrimaryCell, PrimaryCellProps, TableData } from '@revolut-internal/ui-kit-table'

type FadedCellProps<Data extends TableData> = PrimaryCellProps<Data> & {
  isFaded: boolean
}

export const FadedCell = <Data extends TableData>({
  isFaded,
  children,
  ...props
}: PropsWithChildren<FadedCellProps<Data>>) => {
  return (
    <PrimaryCell {...props}>
      {isFaded ? <Text color="grey-tone-50">{children}</Text> : children}
    </PrimaryCell>
  )
}
